module.exports = __webpack_public_path__ + "static/media/betoIntro.4ae4adae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/betoIntro.png
// module id = 71
// module chunks = 0